export default __webpack_public_path__ + "static/31244-cbda1943d16889b38878a9cdbed003f4.jpg";